import { useState, useEffect } from 'react';
import { UserAuth } from 'context/UserAuthContext';
import { get } from 'api/User/self';

// アカウント状態を取得
const useUserAuth = () => {
  const [userAuth, setUserAuth] = useState<UserAuth | undefined>(undefined);

  useEffect(() => {
    get(res => {
      setUserAuth(res);
    });
  }, []);

  return userAuth;
};

export default useUserAuth;
